/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesSupportDtosCreateSupportTicketRequest,
  FacilityFlowCoreModulesSupportDtosSupportTicketDto
} from '.././models';

import { publicCustomInstance } from '../../mutator/public-custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getPublicSupport = () => {
const postApiV1PublicSupportTickets = (
    facilityFlowCoreModulesSupportDtosCreateSupportTicketRequest: FacilityFlowCoreModulesSupportDtosCreateSupportTicketRequest,
 options?: SecondParameter<typeof publicCustomInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>>,) => {
      return publicCustomInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>(
      {url: `/api/v1/public/support/tickets`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesSupportDtosCreateSupportTicketRequest
    },
      options);
    }
  return {postApiV1PublicSupportTickets}};
export type PostApiV1PublicSupportTicketsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPublicSupport>['postApiV1PublicSupportTickets']>>>
